module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv3-60710c9a41f8912a2e14f711eef2b740.jpg";